/**
 * Chinese Flow — Scroll Animations
 * Adapted from Galium Cargo gc-animations.js
 */

(function () {
  'use strict';

  const CLASSES = ['cf-reveal', 'cf-reveal-left', 'cf-reveal-right'];

  function initReveal() {
    const elements = document.querySelectorAll(CLASSES.map(c => '.' + c).join(','));
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    elements.forEach((el) => observer.observe(el));
  }

  document.addEventListener('DOMContentLoaded', initReveal);
})();
